import { formatDate } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Item, Order } from 'app/Shared/models/order.model';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'fichedepolice',
  templateUrl: './fichedepolice.component.html',
  styleUrls: ['./fichedepolice.component.css']
})
export class FichedepoliceComponent implements OnInit {

  @Input() Item: Item;
  @Input() OrderGeted: Order;
  @Input() resa: any;
  @Input() autoDownload: boolean = false;

  @ViewChild('pdfTable', { static: false }) pdfTable!: ElementRef;

  beneficiaries: any[] = [];
  formList: any[] = [];

  constructor(public activeModal: NgbActiveModal) {}

  private getNationalityName(nationality: any): string {
    if (!nationality) return '';
    if (typeof nationality === 'string') return nationality;
    return nationality.name || nationality.nameEn || '';
  }

  private getCountryName(country: any): string {
    if (!country) return '';
    if (typeof country === 'string') return country;
    return country.name || country.nameEn || '';
  }

  ngOnInit(): void {
    console.log('🧾 Item reçu :', this.Item);

    this.beneficiaries = Array.isArray(this.Item?.beneficiaries)
      ? this.Item.beneficiaries
      : [];

    const getDoc = (
      docs: any[],
      typeNames: string[]
    ): { description: any; type: any; code: string; expirationDate?: string; subdocumentType?: any } => {
      if (!Array.isArray(docs) || docs.length === 0)
        return { type: {}, code: '', description: '', expirationDate: '', subdocumentType: null };

      const found = docs.find((d: any) => {
        const typeName = d?.type?.name?.toLowerCase() || '';
        const typeNameEn = d?.type?.nameEn?.toLowerCase() || '';
        return typeNames.some(
          (name) =>
            typeName.includes(name.toLowerCase()) ||
            typeNameEn.includes(name.toLowerCase())
        );
      });

      return found
        ? {
          type: found?.type || {},
          code: found?.code || '',
          description: found?.description || '',
          expirationDate: found?.expirationDate || '',
          subdocumentType: found?.subdocumentType || null
        }
        : { type: {}, code: '', description: '', expirationDate: '', subdocumentType: null };
    };

    this.formList = this.beneficiaries.map((b: any) => {
      const cinDoc = getDoc(b.documents, ['cin']);
      const passportDoc = getDoc(b.documents, ['passeport', 'passport']);
      const residenceDoc = getDoc(b.documents, ['carte de séjour', 'residence card']);

      let description =
        cinDoc.description ||
        passportDoc.description ||
        residenceDoc.description ||
        b.description ||
        '';

      if (description && /^\d{4}-\d{2}-\d{2}$/.test(description)) {
        description = formatDate(description, 'dd/MM/yyyy', 'fr');
      }

      const adresse =
        b.mainAddresse?.street?.trim() ||
        b.mainAddresse?.street2?.trim() ||
        b.description ||
        '';

      // Get subdocument type from the document that has a code
      const subdocumentType = 
        (cinDoc.code && cinDoc.subdocumentType) ||
        (passportDoc.code && passportDoc.subdocumentType) ||
        (residenceDoc.code && residenceDoc.subdocumentType) ||
        null;

      // Get country name
      const countryValue = this.getCountryName(b.country);

      // Get nationality - prioritize nationality field, fallback to country
      const nationalityValue = this.getNationalityName(b.nationality) || countryValue;

      return {
        nom: b.lastName || '',
        prenom: b.firstName || '',
        dateNaissance: b.dob || '',
        email: b.mainEmail?.address || '',
        telephone: b.mainPhone?.number || '',
        pays: countryValue,
        nationalite: nationalityValue,
        profession: b.comment || '',
        code: cinDoc.code || passportDoc.code || '',
        typeDoc:
          cinDoc.type?.name ||
          cinDoc.type?.nameEn ||
          passportDoc.type?.name ||
          passportDoc.type?.nameEn ||
          '',
        subDocType: subdocumentType?.name || subdocumentType?.nameEn || '',
        carteSejour: residenceDoc.code || '',
        typeCarte:
          residenceDoc.type?.name ||
          residenceDoc.type?.nameEn ||
          '',
        description: description,
        numEntree: b.entryNumber || b.rib || '',
        dateArrivee: this.Item?.startService || '',
        dateDepart: this.Item?.endService || '',
        numChambre: this.resa?.roomName || this.resa?.otherNumber || '',
        adresse: adresse,
        signature: ''
      };
    });

    if (this.formList.length === 0 && this.Item?.customer) {
      const c = this.Item.customer;
      const cinDoc = getDoc(c.documents, ['cin']);
      const passportDoc = getDoc(c.documents, ['passeport', 'passport']);
      const residenceDoc = getDoc(c.documents, ['carte de séjour', 'residence card']);

      let description =
        cinDoc.description ||
        passportDoc.description ||
        residenceDoc.description ||
        c.description ||
        '';

      if (description && /^\d{4}-\d{2}-\d{2}$/.test(description)) {
        description = formatDate(description, 'dd/MM/yyyy', 'fr');
      }

      const adresse =
        c.mainAddresse?.street?.trim() ||
        c.mainAddresse?.street2?.trim() ||
        c.description ||
        '';

      // Get subdocument type from the document that has a code
      const subdocumentType = 
        (cinDoc.code && cinDoc.subdocumentType) ||
        (passportDoc.code && passportDoc.subdocumentType) ||
        (residenceDoc.code && residenceDoc.subdocumentType) ||
        null;

      // Get country name
      const countryValue = this.getCountryName(c.country);

      // Get nationality - prioritize nationality field, fallback to country
      const nationalityValue = this.getNationalityName((c as any).nationality) || countryValue;

      this.formList.push({
        nom: c.lastName || '',
        prenom: c.firstName || '',
        dateNaissance: c.dob || '',
        email: c.mainEmail?.address || '',
        telephone: c.mainPhone?.number || '',
        pays: countryValue,
        nationalite: nationalityValue,
        profession: c.comment || c.workingAt || '',
        code: cinDoc.code || passportDoc.code || '',
        typeDoc:
          cinDoc.type?.name ||
          cinDoc.type?.nameEn ||
          passportDoc.type?.name ||
          passportDoc.type?.nameEn ||
          '',
        subDocType: subdocumentType?.name || subdocumentType?.nameEn || '',
        carteSejour: residenceDoc.code || '',
        typeCarte:
          residenceDoc.type?.name ||
          residenceDoc.type?.nameEn ||
          '',
        description: description,
        numEntree: c.entryNumber || c.rib || '',
        dateArrivee: this.Item?.startService || '',
        dateDepart: this.Item?.endService || '',
        numChambre: this.resa?.roomName || this.resa?.otherNumber || '',
        adresse: adresse,
        signature: ''
      });
    }

    console.log('✅ Liste des formulaires générés :', this.formList);
  }

  loadImage(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.crossOrigin = 'Anonymous';
      img.onload = () => resolve(img);
      img.onerror = (e) => reject(e);
    });
  }

  async downloadPDF() {
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = 210;
    const pageHeight = 297;
    const marginX = 10; 
    const marginY = 10;

    // 1. Load the Logo image
    const logoUrl = 'assets/img/valeria.png'; 
    let logoBase64: string | null = null;
    
    try {
      const img = await this.loadImage(logoUrl);
      const c = document.createElement('canvas');
      c.width = img.width;
      c.height = img.height;
      const ctx = c.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0);
        logoBase64 = c.toDataURL('image/png');
      }
    } catch (error) {
      console.warn('Logo could not be loaded', error);
    }

    const originalElement = document.getElementById('pdfTable');
    if (!originalElement) return;

    // 2. Clone and Setup Hidden View
    const clonedWrapper = originalElement.cloneNode(true) as HTMLElement;
    
    clonedWrapper.style.position = 'fixed';
    clonedWrapper.style.top = '-10000px';
    clonedWrapper.style.left = '0';
    clonedWrapper.style.width = '1200px'; 
    clonedWrapper.style.zIndex = '-100';
    clonedWrapper.style.backgroundColor = '#ffffff';

    document.body.appendChild(clonedWrapper);

    // 3. Transform Inputs - REDUCED HEIGHT & SPACING
    const inputs = clonedWrapper.querySelectorAll('input, textarea');

    inputs.forEach((input: any) => {
      const value = input.value || input.placeholder || '';
      const div = document.createElement('div');

      div.style.border = '1px solid #ccc';
      div.style.borderRadius = '6px';
      div.style.backgroundColor = '#fafafa';
      div.style.color = '#333';
      div.style.fontFamily = "'Segoe UI', Arial, sans-serif";
      div.style.fontSize = '13px';  // Slightly smaller font

      // REDUCED HEIGHT to fit more fields
      div.style.height = '32px';  // Was 36px
      div.style.boxSizing = 'border-box';

      // Center vertically with reduced margin
      div.style.marginTop = '8px';  // Was 8px
      div.style.paddingLeft = '12px';    

      div.style.display = 'block';
      div.style.whiteSpace = 'nowrap';
      div.style.overflow = 'hidden';
      div.style.textOverflow = 'ellipsis';

      div.textContent = value;
      input.replaceWith(div);
    });

    // 4. Reduce spacing between form rows
    const formRows = clonedWrapper.querySelectorAll('.form-row');
    formRows.forEach((row: any) => {
      row.style.marginBottom = '8px';  // Reduce gap between fields
    });

    // 5. Reduce label bottom margin
    const labels = clonedWrapper.querySelectorAll('.form-row label');
    labels.forEach((label: any) => {
      label.style.marginBottom = '2px';  // Was likely 4px or more
      label.style.fontSize = '10px';  
    });

    // 6. Process containers
    const containers = clonedWrapper.querySelectorAll('.bulletin-container');
    
    for (let i = 0; i < containers.length; i++) {
      const container = containers[i] as HTMLElement;

      container.style.maxWidth = 'none';
      container.style.width = '100%';
      container.style.margin = '0';
      container.style.padding = '10px 30px';  // REDUCED padding (was 20px 40px)
      container.style.boxSizing = 'border-box';
      container.style.boxShadow = 'none';
      container.style.border = 'none';

      const title = container.querySelector('.title') as HTMLElement;
      if (title) {
        // title.style.marginTop = '8px'; 
        title.style.fontSize = '13px';  // Slightly smaller
        title.style.paddingLeft = '12px';  // Reduce padding
      }

      // Reduce guest header spacing
      const guestHeader = container.querySelector('.guest-header') as HTMLElement;
      if (guestHeader) {
        // guestHeader.style.marginBottom = '8px';  
        // guestHeader.style.paddingLeft = '12px'; 
        guestHeader.style.fontSize = '12px';
      }

      // ADD LOGO AT THE VERY TOP WITH MINIMAL MARGIN
      if (logoBase64) {
        const logoImg = document.createElement('img');
        logoImg.src = logoBase64;
        logoImg.style.width = '160px';  // Slightly smaller (was 180px)
        logoImg.style.display = 'block';
        logoImg.style.margin = '0 auto 8px auto';  // MINIMAL margin (was 10px)
        container.prepend(logoImg);
      }

      if (i > 0) pdf.addPage();

      const canvas = await html2canvas(container, {
        scale: 2, 
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      });

      const imgData = canvas.toDataURL('image/png');
      const contentWidth = pageWidth - (marginX * 2);
      const imgHeight = (canvas.height * contentWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', marginX, marginY, contentWidth, imgHeight, '', 'FAST');
    }

    document.body.removeChild(clonedWrapper);
    pdf.save('Bulletin-Police-Hotel.pdf');
  }

  // async downloadPDF() {
  //   const pdf = new jsPDF('p', 'mm', 'a4');
  //   const pageWidth = 210;
  //   const pageHeight = 297;
  //   const marginX = 10; 
  //   const marginY = 10;

  //   // 1. Load the Logo image
  //   const logoUrl = 'assets/img/valeria.png'; 
  //   let logoBase64: string | null = null;
    
  //   try {
  //     const img = await this.loadImage(logoUrl);
  //     const c = document.createElement('canvas');
  //     c.width = img.width;
  //     c.height = img.height;
  //     const ctx = c.getContext('2d');
  //     if (ctx) {
  //       ctx.drawImage(img, 0, 0);
  //       logoBase64 = c.toDataURL('image/png');
  //     }
  //   } catch (error) {
  //     console.warn('Logo could not be loaded', error);
  //   }

  //   const originalElement = document.getElementById('pdfTable');
  //   if (!originalElement) return;

  //   // 2. Clone and Setup Hidden View
  //   const clonedWrapper = originalElement.cloneNode(true) as HTMLElement;
    
  //   clonedWrapper.style.position = 'fixed';
  //   clonedWrapper.style.top = '-10000px';
  //   clonedWrapper.style.left = '0';
  //   clonedWrapper.style.width = '1200px'; 
  //   clonedWrapper.style.zIndex = '-100';
  //   clonedWrapper.style.backgroundColor = '#ffffff';

  //   document.body.appendChild(clonedWrapper);

  //   const inputs = clonedWrapper.querySelectorAll('input, textarea');

  //   inputs.forEach((input: any) => {
  //     const value = input.value || input.placeholder || '';
  //     const div = document.createElement('div');

  //     // Styling
  //     div.style.border = '1px solid #ccc';
  //     div.style.borderRadius = '6px';
  //     div.style.backgroundColor = '#fafafa';
  //     div.style.color = '#333';
  //     div.style.fontFamily = "'Segoe UI', Arial, sans-serif";
  //     div.style.fontSize = '14px';

  //     div.style.height = '36px'; 
  //     div.style.boxSizing = 'border-box';

  //     div.style.marginTop = '8px';
  //     div.style.paddingLeft = '15px';    

  //     div.style.display = 'block';
  //     div.style.whiteSpace = 'nowrap';
  //     div.style.overflow = 'hidden';
  //     div.style.textOverflow = 'ellipsis';

  //     div.textContent = value;
  //     input.replaceWith(div);
  //   });

  //   const containers = clonedWrapper.querySelectorAll('.bulletin-container');
    
  //   for (let i = 0; i < containers.length; i++) {
  //     const container = containers[i] as HTMLElement;

  //     container.style.maxWidth = 'none';
  //     container.style.width = '100%';
  //     container.style.margin = '0';
  //     container.style.padding = '20px 40px'; 
  //     container.style.boxShadow = 'none';
  //     container.style.border = 'none';

  //     const title = container.querySelector('.title') as HTMLElement;
  //     if (title) title.style.marginTop = '10px';

  //     if (logoBase64) {
  //       const logoImg = document.createElement('img');
  //       logoImg.src = logoBase64;
  //       logoImg.style.width = '180px'; 
  //       logoImg.style.display = 'block';
  //       logoImg.style.margin = '0 auto 10px auto'; 
  //       container.prepend(logoImg);
  //     }

  //     if (i > 0) pdf.addPage();

  //     const canvas = await html2canvas(container, {
  //       scale: 2, 
  //       useCORS: true,
  //       logging: false,
  //       backgroundColor: '#ffffff'
  //     });

  //     const imgData = canvas.toDataURL('image/png');
  //     const contentWidth = pageWidth - (marginX * 2);
  //     const imgHeight = (canvas.height * contentWidth) / canvas.width;

  //     pdf.addImage(imgData, 'PNG', marginX, marginY, contentWidth, imgHeight, '', 'FAST');
  //   }

  //   document.body.removeChild(clonedWrapper);
  //   pdf.save('Bulletin-Police-Hotel.pdf');
  // }

  closeModal(): void {
    this.activeModal.dismiss();
  }

  printForms() {
    setTimeout(() => {
      const pdfElement = document.getElementById('pdfTable');
      if (!pdfElement) {
        console.warn('⚠️ Élément #pdfTable introuvable.');
        return;
      }

      const cloned = pdfElement.cloneNode(true) as HTMLElement;

      const inputs = cloned.querySelectorAll('input, textarea');
      inputs.forEach((input: HTMLInputElement | HTMLTextAreaElement) => {
        const value = input.value || input.placeholder || '';
        const span = document.createElement('div');
        span.style.border = '1px solid #ccc';
        span.style.padding = '4px 8px';
        span.style.marginBottom = '4px';
        span.style.borderRadius = '4px';
        span.style.backgroundColor = '#fafafa';
        span.style.minHeight = '20px';
        span.textContent = value;
        input.replaceWith(span);
      });

      const printContents = cloned.innerHTML;

      const popupWin = window.open('', '_blank', 'width=900,height=1200');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
        <head>
          <title>Bulletins Individuels</title>
          <style>
            @page {
              size: A4;
              margin: 15mm;
            }
            
            * {
              box-sizing: border-box;
            }
            
            body {
              font-family: 'Segoe UI', Arial, sans-serif;
              margin: 0;
              padding: 20px;
              color: #333;
              font-size: 12px;
              background: #fff;
              line-height: 1.4;
            }
            
            .bulletin-container {
              border: 1px solid #ddd;
              border-radius: 8px;
              padding: 20px 25px;
              margin: 0 auto 20px;
              page-break-after: always;
              background: #fff;
              max-width: 100%;
            }
            
            .bulletin-container:last-child {
              page-break-after: auto;
            }
            
            .title {
              text-align: center;
              font-size: 14px;
              font-weight: bold;
              text-transform: uppercase;
              border: 2px solid #333;
              padding: 10px 15px;
              margin: 0 auto 20px;
              display: block;
              background: #f9f9f9;
              border-radius: 6px;
              color: #333;
            }
            
            .title span {
              font-weight: normal;
              color: #333; /* Same color as French */
            }
            
            .guest-header {
              background: linear-gradient(135deg, #f0f0f0, #e8e8e8);
              padding: 8px 12px;
              font-weight: bold;
              margin-bottom: 15px;
              border-left: 4px solid #007bff;
              font-size: 13px;
              border-radius: 0 4px 4px 0;
            }
            
            .form-row {
              margin-bottom: 10px;
              page-break-inside: avoid;
            }
            
            .form-row label {
              font-weight: 600;
              display: block;
              margin-bottom: 4px;
              font-size: 11px;
              color: #444;
            }
            
            .form-row label span {
              font-weight: normal;
              color: #444; /* Same color as French */
            }
            
            div[style*='border'] {
              background: #fafafa;
              font-size: 12px;
            }
            
            .divider {
              display: none;
            }
            
            @media print {
              body {
                padding: 0;
              }
              
              .bulletin-container {
                page-break-after: always;
                margin: 0;
                border: 1px solid #ccc;
              }
              
              .bulletin-container:last-child {
                page-break-after: auto;
              }
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
        </html>
      `);
      popupWin.document.close();
    }, 500);
  }
}